import classNames from 'classnames'

export function LandscapeGrid({
  children,
  className,
  ...rest
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={classNames(
        className,
        'grid grid-cols-1 gap-x-4 gap-y-8 px-4 sm:px-8 md:flex md:flex-wrap md:px-12 xl:px-16',
      )}
      {...rest}
    >
      {children}
    </div>
  )
}
